import { useEffect, useState } from "react";
import { debounce } from "../hooks/debounce";
import { net } from "../../../database";

interface SelectOption {
  _id: string;
  name: string;
}

interface CustomSelectProps {
  label?: string;
  value: string;
  setValue: (val: string) => void;
  options: SelectOption[] | string[] | string;
  className?: string;
  labelClass?: string;
  helperText?: string;
  helperClass?: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  error?: boolean;
  url?: string,
  field?: string,
  delay?: number
  update?: Function,
  width?: number
}

export type OptionType = {
  _id: string,
  name: string,
}

export default function Select({
  label,
  value,
  setValue,
  options,
  className = "",
  helperText = "",
  startAdornment,
  endAdornment,
  error = false,
  url,
  field,
  delay = 1000,
  update,
  width=200
}: CustomSelectProps){
  const [open, setOpen] = useState(false);
  const [first, setFirst] = useState(false);
  const [normalizedOptions, setNormalizedOptions]:[SelectOption[],Function] = useState([])
  
  useEffect(() => {
    if (typeof options === "string") {
       
     getOptions(options)
     }
     else
     {
       if (typeof options[0] === "string") {
        setNormalizedOptions(options.map(o=>({_id: o, name: o})))
       } else {
         setNormalizedOptions(options)
     }
     }
  },[options])
    
      useEffect(() => {
        if (url && field) {
          const db = debounce(url, field, value, first, delay);
          setFirst(true);
          return () => {
            if (typeof db === "function") db();
          };
        }
      }, [value])
  

  
  const getOptions = async (options: string) => {
    const opts = await net.get(options)

    if (opts === undefined) {
      setNormalizedOptions([]); return
    }

    setNormalizedOptions(opts
      .sort((a: OptionType, b: OptionType) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
    }

  
    
      let labelClass = "text-xs pl-1 ";
      let helperClass = "h-3 text-xs pt-1 pl-1 mb-2 ";

      if (error) {
        labelClass += "text-red-500 ";
        helperClass += "text-red-500 ";
      } else {
        labelClass += "text-cyan-700 ";
        helperClass += "text-gray-500 ";
      }

  return (
    <div className="relative">
      <div className={labelClass}>{label}</div>
      <div
        className={`flex items-center border p-2 pl-3 rounded-lg cursor-pointer ${
          error ? "border-red-500" : "border-gray-300"
        }`}
        onClick={() => setOpen(!open)}
        style={{width}}
      >
        {startAdornment && (
          <div className="px-2 text-gray-600 mr-1">{startAdornment}</div>
        )}
        <div className={`flex-1 ${className}`}>{normalizedOptions.find(o => o._id === value)?.name || "Select..."}</div>
        {endAdornment && (
          <div className="px-2 text-gray-600 ml-1">{endAdornment}</div>
        )}
        <div className="ml-2 text-gray-500">▾</div>
      </div>

      {open && (
        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded shadow">
          {normalizedOptions.map((opt) => (
            <div
              key={opt._id}
              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                opt._id === value ? "bg-gray-200 font-semibold" : ""
              }`}
              onClick={() => {
                setValue(opt._id);
                if(update) update(normalizedOptions.find(o=>o._id===opt._id))
                setOpen(false);
              }}
            >
              {opt.name}
            </div>
          ))}
        </div>
      )}

      <div className={helperClass}>{helperText}      </div>
    </div>
  );
};
